import React from 'react';
import * as listImageTextInsidesStyle
  from '../../styles/internal-page/list-image-text-insides.module.scss';
import { useTranslation } from 'react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const ListImageTextInsides = ({ content }) => {
  const {t} = useTranslation();
  if (content?.articles?.length === 0) {
    return null;
  }

  return (
    <div className={listImageTextInsidesStyle.root}>
      <h2>
        {t('list.image.text.inside.title')}
      </h2>
      <div className={listImageTextInsidesStyle.container}>
        {content?.articles?.map((item, index) => (
          <Link className={listImageTextInsidesStyle.divRoot}
            key={index}
            to={item.url}
          >
            <GatsbyImage
              alt={''}
              className={listImageTextInsidesStyle.image}
              image={getImage(item.picture?.imageFile)}
              loading="eager"
            />
            <div className={listImageTextInsidesStyle.containerText}>
              <p className={listImageTextInsidesStyle.text}>
                {item.title}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

ListImageTextInsides.propTypes = {
  content: PropTypes.shape({
    articles: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      picture: PropTypes.shape({
        imageFile: PropTypes.object,
      }),
      title: PropTypes.string.isRequired,
    })).isRequired,
  }),
};

export default ListImageTextInsides;